import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../components/SEO";
import Consultation from "./Consultation";
import pranaamElevation from "../assets/images/PRANAAM-ELEVATION.png";
import pbr from "../assets/images/PBR.png";
import samuel from "../assets/images/Samuel.png";
import amvi from "../assets/images/clients/amvi-hospital.png";
import bhurngi from "../assets/images/clients/bhrungi-hospital.png";
import citineurocenter from "../assets/images/clients/citineurocenter-hospital.png";
import dhruva from "../assets/images/clients/dhruva-hospital.png";
import haritha from "../assets/images/clients/haritha-hospital.png";
import hilife from "../assets/images/clients/hilife-hospital.png";
import kiran from "../assets/images/clients/kiran-hospital.png";
import kiran2 from "../assets/images/clients/kiran-hospitals.png";
import lalitha from "../assets/images/clients/lalitha-hospital.png";
import lotus from "../assets/images/clients/lotus-hospital.png";
import medistart from "../assets/images/clients/medistar-hospital.png";
import miracle from "../assets/images/clients/miracle-hospital.png";
import mms from "../assets/images/clients/mms-hospital.png";
import murugun from "../assets/images/clients/murugun-hospital.png";
import nacro from "../assets/images/clients/nacro-hospital.png";
import neelima from "../assets/images/clients/neelima-hospital.png";
import onecardiaccenter from "../assets/images/clients/one-cardiac-center-hospital.png";
import paarthiv from "../assets/images/clients/paarthiv-hospital.png";
import padmaja from "../assets/images/clients/padmaja-hospital.png";
import premier from "../assets/images/clients/premier-hospital.png";
import remedy from "../assets/images/clients/remedy-hospital.png";
import rnc from "../assets/images/clients/rnc-hospital.png";
import samuel2 from "../assets/images/clients/samuel-hospital.png";
import samyukthi from "../assets/images/clients/samyukthi-hospital.png";
import shree from "../assets/images/clients/shree-veda-hospital.png";
import shreya from "../assets/images/clients/shreya-hospital.png";
import shroff from "../assets/images/clients/shroff-hospital.png";
import sidarth from "../assets/images/clients/sidarth-hospital.png";
import sudha from "../assets/images/clients/sudha-hospital.png";
import sunrise from "../assets/images/clients/sunrise-hospital.png";
import tejakidneycare from "../assets/images/clients/teja-kidney-care-hospital.png";
import vcare from "../assets/images/clients/vcare-hospital.png";
import vinod from "../assets/images/clients/vinod-hospital.png";
import lifetime from "../assets/images/services/lifetime.png";
import iso from "../assets/images/services/iso.png";
import nabh from "../assets/images/services/nabh.png";
import ontimedelivery from "../assets/images/services/ontimedelivery.png";
import safetycheck from "../assets/images/services/safetycheck.png";
import service from "../assets/images/services/service.png";
import hospitalbuild from "../assets/images/services/hospitalbuild.png";
import jalapathihospital from "../assets/images/projects/jalapathi-hospital.png";
import miraclehospial from "../assets/images/projects/miracle-hospital.png";
import vinodhospital from "../assets/images/projects/vinod-hospital.png";
import medistarhospital from "../assets/images/projects/medistar-hospital.png";
import pbrhospital from "../assets/images/projects/pbr-hospital.png";
import mmshospital from "../assets/images/projects/mms-hospital.png";
import slider1 from "../assets/images/slider/slider-1.png";
import slider2 from "../assets/images/slider/slider-2.png";
import slider3 from "../assets/images/slider/slider-3.png";
import slider4 from "../assets/images/slider/slider-4.png";
import mobileBanner1 from "../assets/images/slider/mobile-banner-1.png";
import mobileBanner2 from "../assets/images/slider/mobile-banner-2.png";
import mobileBanner3 from "../assets/images/slider/mobile-banner-3.png";
import mobileBanner4 from "../assets/images/slider/mobile-banner-4.png";

import operationtheator from "../assets/images/operation-theator.png";
import diagnostic from "../assets/images/Diagnosics.jpg";
import Patientward from "../assets/images/Patientward.jpg";
import Pharmacy from "../assets/images/Pharmacy.jpg";
import calculator from "../assets/images/calculator.avif";

import client1 from "../assets/images/Doctors/Client-1.jpeg";
import client2 from "../assets/images/Doctors/Client-2.jpeg";
import client3 from "../assets/images/Doctors/Client-3.avif";

import Diagnosticglimpse from "../assets/images/Glimpse/Diagnosics.jpg";
import Icusuitglimpse from "../assets/images/Glimpse/Icusuit.jpg";
import Isolationglimpse from "../assets/images/Glimpse/Isolation.jpg";
import Labandpathologyglimpse from "../assets/images/Glimpse/LabAndPathology.png";
import Maternityglimpse from "../assets/images/Glimpse/Maternity.jpg";
import Nursestationglimpse from "../assets/images/Glimpse/Nursingstation.webp";
import Oncologyglimpse from "../assets/images/Glimpse/Oncology.jpeg";
import Otsuitglimpse from "../assets/images/Glimpse/Otsuit.png";
import Pharmacyglimpse from "../assets/images/Glimpse/Pharmacy.jpg";
import Patientwardglimpse from "../assets/images/Glimpse/Patientward.jpg";
import Paediatricsglimpse from "../assets/images/Glimpse/Paediatricward.avif";
import Receptionglimpse from "../assets/images/Glimpse/ReceptionLobby.png";


const FONT_LINK = `https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Inter:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap`;

const HOSPITAL_SLIDES = [
  {
    img: slider1,
    mobileImg: mobileBanner1,
    category: "Hospital Design & Build",
    title: "Building World-Class Hospital Infrastructure",
    fetchPriority:"high",
    desc: "From concept to commissioning, PR Hospital Designers delivers NABH-compliant healthcare spaces — on time, every time.",
    stats: [["200+", "Hospitals Built"], ["10+", "Years Experience"], ["146", "Quality Checks"]],
    cta: "Book Free Consultation",
  },
  {
    img: slider2,
    mobileImg: mobileBanner2,
    category: "OT & ICU Fit-Outs",
    title: "Sterile, Compliant OT & ICU Suites",
    desc: "Modular operation theatres and intensive care units engineered to international clinical standards.",
    stats: [["200+", "Hospitals Built"], ["10+", "Years Experience"], ["146", "Quality Checks"]],
    cta: "Get an Estimate",
  },
  {
    img: slider3,
    mobileImg: mobileBanner3,
    category: "Diagnostic Centres",
    title: "Diagnostic Centres Designed for Precision",
    desc: "Radiology, pathology and imaging facilities planned for seamless patient and workflow movement.",
    stats: [["200+", "Hospitals Built"], ["10+", "Years Experience"], ["146", "Quality Checks"]],
    cta: "Book Free Consultation",
  },
  {
    img: slider4,
    mobileImg: mobileBanner4,
    category: "Patient Ward Design",
    title: "Healing-Focused Patient Ward Environments",
    desc: "Inpatient wards and recovery spaces built around comfort, safety and infection control.",
    stats: [["200+", "Hospitals Built"], ["10+", "Years Experience"], ["146", "Quality Checks"]],
    cta: "Start Your Project",
  },
];

const HOSPITAL_OFFERINGS = [
  { title: "OT & ICU Fit-Outs", subtitle: "Sterile, compliant operation theatres and intensive care units", img: operationtheator, path: "/ot-suite-designs" },
  { title: "Diagnostic Centres", subtitle: "Radiology, pathology and imaging centre design & build", img: diagnostic, path: "/diagnostic-room-designs" },
  { title: "Patient Ward Design", subtitle: "Healing-focused inpatient and general ward environments", img: Patientward, path: "/patient-ward-designs" },
  { title: "Pharmacy & Reception", subtitle: "Functional pharmacy layouts and welcoming reception areas", img: Pharmacy, path: "/pharmacy-designs" },
];

const WHY_CHOOSE_HOSPITAL = [
  { icon: lifetime, title: "Lifetime Warranty" },
  { icon: ontimedelivery, title: "On-Time Delivery" },
  { icon: safetycheck, title: "146 Quality Checks" },
  { icon: hospitalbuild, title: "200+ Hospitals Built" },
  { icon: nabh, title: "NABH Compliant" },
  { icon: iso, title: "ISO Certified" },
  { icon: service, title: "24/7 Project Support" },
];

const HOSPITAL_CALCULATORS = [
  { title: "OT / ICU Fit-Out", desc: "Get an estimate for your operation theatre or ICU project", iconL: operationtheator, iconR: calculator },
  { title: "Diagnostic Centre", desc: "Know the approximate cost for your diagnostic lab setup", iconL: diagnostic, iconR: calculator },
  { title: "Patient Ward Block", desc: "Estimate the cost for full ward design and construction", iconL: Patientward, iconR: calculator },
];

const HOSPITAL_STORIES = [
  { label: "Jalapathi Reddy Hospital", landscape: true, img: jalapathihospital },
  { label: "Miracle Hospital", landscape: true, img: miraclehospial },
  { label: "Vinod Hospital", landscape: true, img: vinodhospital },
  { label: "Medistar Hospital", landscape: true, img: medistarhospital },
  { label: "PBR Multi Speciality Hospital", landscape: true, img: pbrhospital },
  { label: "MMS Hospital", landscape: true, img: mmshospital },
];

const HOSPITAL_TESTIMONIALS = [
  { name: "Dr. Suresh Reddy", location: "Panacea Hospital, RC Puram", review: "PR Hospital Designers transformed our hospital with exceptional precision. Fully NABH compliant and delivered ahead of schedule.", img: client1 },
  { name: "Dr. Sreeveena", location: "PBR Multi Speciality Hospital, IDA Bollarum", review: "Our OT complex was designed and built by PR Hospital Designers. Zero punch-list items at handover — speaks volumes about their quality.", img: client2 },
  { name: "Dr. Neelima", location: "Neelima Hospital, Moti Nagar", review: "The layout improved patient flow by 40%. Brilliant spatial planning with real clinical expertise.", img: client3 },
];

const HOSPITAL_GALLERY_SLIDES = [
  [
    { title: "OT Complex", city: "Fortis Healthcare, Mumbai", span: 2, img: Otsuitglimpse, path: "/ot-suite-designs" },
    { title: "ICU Suite", city: "Apollo Hospitals, Delhi", span: 1, img: Icusuitglimpse, path: "/icu-layout-designs" },
    { title: "Reception", city: "Max Hospital, Gurgaon", span: 1, img: Receptionglimpse, path: "/reception-lobby-designs" },
    { title: "Patient Ward", city: "Sunrise Hospital, Kochi", span: 1, img: Patientwardglimpse, path: "/patient-ward-designs" },
    { title: "Diagnostic Lab", city: "Medanta, Lucknow", span: 2, img: Diagnosticglimpse, path: "/diagnostic-room-designs" },
    { title: "Pharmacy", city: "Kims Hospital, Hyd", span: 1, img: Pharmacyglimpse, path: "/pharmacy-designs" },
  ],
  [
    { title: "Isolation Ward", city: "Rainbow Hospital, Hyd", span: 1, img: Isolationglimpse, path: "/isolation-room-designs" },
    { title: "Lab & Pathology", city: "Yashoda Hospital, Hyd", span: 2, img: Labandpathologyglimpse, path: "/lab-pathology-designs" },
    { title: "Maternity Ward", city: "Care Hospital, Hyd", span: 1, img: Maternityglimpse, path: "/maternity-suite-designs" },
    { title: "Nursing Station", city: "NIMS, Hyderabad", span: 2, img: Nursestationglimpse, path: "/nursing-station-designs" },
    { title: "Oncology Unit", city: "Global Hospital, Hyd", span: 1, img: Oncologyglimpse, path: "/oncology-unit-designs" },
    { title: "Paediatric Ward", city: "AIG Hospital, Hyd", span: 1, img: Paediatricsglimpse, path: "/paediatric-ward-designs" },
  ],
];

const MAGAZINE_POSTS = [
  { title: "Pranaam Hospitals & Maternity Matters", author: "PR Hospital Designers Team", img: pranaamElevation },
  { title: "PBR MULTISPECIALITY HOSPITAL", author: "PR Hospital Designers Team", img: pbr },
  { title: "DR.SAMUEL SUPER SPECIALITY HOSPITAL", author: "PR Hospital Designers Team", img: samuel },
];

const NEWS_LOGOS = [
  { name: "Amvi Hospital", img: citineurocenter },
  { name: "Bhrungi Hospital", img: bhurngi },
  { name: "Citi Neuro Centre", img: citineurocenter },
  { name: "Dhruva Hospital", img: dhruva },
  { name: "Haritha Hospital", img: haritha },
  { name: "Hilife Hospital", img: hilife },
  { name: "Kiran Hospital", img: kiran },
  { name: "Kiran Hospitals", img: kiran2 },
  { name: "Lalitha Hospital", img: lalitha },
  { name: "Lotus Hospital", img: lotus },
  { name: "Medistart Hospital", img: medistart },
  { name: "Miracle Hospital", img: miracle },
  { name: "MMS Hospital", img: mms },
  { name: "Murugun Hospital", img: murugun },
  { name: "Nacro Hospital", img: nacro },
  { name: "Neelima Hospital", img: neelima },
  { name: "One Cardiac Center Hospital", img: onecardiaccenter },
  { name: "Paarthiv Hospital", img: paarthiv },
  { name: "Padmaja Hospital", img: padmaja },
  { name: "Premier Hospital", img: premier },
  { name: "Remedy Hospital", img: remedy },
  { name: "RNC Hospital", img: rnc },
  { name: "Samuel Hospital", img: samuel2 },
  { name: "Samyukthi Hospital", img: samyukthi },
  { name: "Shree Veda Hospital", img: shree },
  { name: "Shreya Hospital", img: shreya },
  { name: "Shroff Hospital", img: shroff },
  { name: "Sidarth Hospital", img: sidarth },
  { name: "Sudha Hospital", img: sudha },
  { name: "Sunrise Hospital", img: sunrise },
  { name: "Teja Kidney Care Hospital", img: tejakidneycare },
  { name: "Vcare Hospital", img: vcare },
  { name: "Vinod Hospital", img: vinod },
];

const FAQS = [
  { q: "1. Why do I need a hospital infrastructure specialist?", a: "A specialist ensures your clinical spaces are compliant, functional, and built to international standards. PR Hospital Designers' team handles everything from regulatory approvals to final fit-out." },
  { q: "2. Why is PR Hospital Designers perfect for your hospital project?", a: "PR Hospital Designers brings 30+ years of healthcare construction expertise. We deliver NABH-compliant, ISO-certified environments with 24/7 project support and on-time delivery guarantees." },
  { q: "3. What services are included in hospital infrastructure?", a: "PR Hospital Designers covers OT & ICU fit-outs, diagnostic centre design, patient ward construction, pharmacy layouts, reception areas, civil work, MEP services, and medical gas installations." },
  { q: "4. How much does a hospital project cost?", a: "Costs vary by project scope. OT fit-outs start from ₹25L, ICU suites from ₹40L, and full ward blocks are priced on area and specifications. Contact us for a detailed estimate." },
  { q: "5. What are the timelines for hospital project completion?", a: "Modular OT fit-outs can be completed in 45–60 days. Full ward blocks and diagnostic centres typically take 90–180 days depending on scale and approvals." },
  { q: "6. Do you handle NABH compliance documentation?", a: "Yes. Our team assists with all NABH and JCI compliance documentation, infection control planning, and regulatory submissions as part of the project scope." },
];

/* ─── GLOBAL STYLESHEET ─────────────────────────────────────────────────────
   Every static style lives here as a class. The only properties still set
   inline in JSX are the handful that are recalculated every animation frame
   from component state (slide position, progress-bar width, ticker offsets)
   — those are passed in as CSS custom properties and consumed here via var().
──────────────────────────────────────────────────────────────────────────── */
const GLOBAL_CSS = `
  @import url('${FONT_LINK}');
  * { box-sizing: border-box; }
  ::-webkit-scrollbar { width: 5px; height: 5px; }
  ::-webkit-scrollbar-track { background: #ECEEF6; }
  ::-webkit-scrollbar-thumb { background: #CDD1E0; border-radius: 100px; }
  ::-webkit-scrollbar-thumb:hover { background: #555763; }
  img { display: block; }
  html { scroll-behavior: smooth; }
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes popIn { from { opacity: 0; transform: scale(0.92) translateY(16px); } to { opacity: 1; transform: scale(1) translateY(0); } }

  .page { font-family: 'Inter', 'Montserrat', sans-serif; background: #fff; color: #343F86; overflow-x: hidden; }

  /* ── Offset for fixed Navbar ─────────────────────────────────────────── */
  .page { padding-top: 106px; }
  @media (max-width: 900px) { .page { padding-top: 60px; } }
  @media (max-width: 480px) { .page { padding-top: 56px; } }

  /* ── Hero Slider ──────────────────────────────────────────────────────── */
  .hero-slider-wrap { position: relative; width: 100%; height: calc(100vh - 106px); min-height: 480px; overflow: hidden; background: #343F86; }
  .hero-track { display: flex; align-items: flex-start; height: 110%; transform: translateX(var(--tx, 0)); transition: transform 0.7s cubic-bezier(0.77,0,0.175,1); }
  .hero-slide { min-width: 100%; width: 100%; height: 100%; position: relative; flex-shrink: 0; cursor: pointer; }
  .hero-img { width: 100%; height: 100%; object-fit: cover; }
  .hero-img-mobile { display: none; }
  .hero-grad { position: absolute; inset: 0; background: linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.20) 50%, transparent 100%); }
  .hero-content { position: absolute; inset: 0; display: flex; flex-direction: column; justify-content: flex-end; padding: 0 72px 130px; }
  .hero-cat { display: inline-flex; align-items: center; gap: 8px; margin-bottom: 16px; font-size: 10px; letter-spacing: 3px; text-transform: uppercase; color: rgba(255,255,255,0.65); font-weight: 700; }
  .hero-cat-dot { width: 6px; height: 6px; border-radius: 50%; background: rgba(255,255,255,0.60); }
  .hero-title { font-size: clamp(28px,4.2vw,30px); font-weight: 700; color: #fff; line-height: 1.1; max-width: 680px; margin-bottom: 16px; }
  .hero-desc { font-size: 14px; color: rgba(255,255,255,0.75); max-width: 480px; line-height: 1.8; margin-bottom: 28px; }
  .hero-stats { display: flex; gap: 40px; margin-bottom: 32px; }
  .hero-stat { border-left: 2px solid rgba(255,255,255,0.35); padding-left: 14px; }
  .hero-stat-num { font-size: 22px; font-weight: 700; color: #fff; line-height: 1; }
  .hero-stat-label { font-size: 9px; letter-spacing: 1.5px; text-transform: uppercase; color: rgba(255,255,255,0.55); margin-top: 3px; }
  .hero-cta { display: inline-flex; align-items: center; gap: 10px; background: transparent; border: 1px solid rgba(255,255,255,0.45); color: #7FD0DA; padding: 13px 28px; font-size: 11px; letter-spacing: 2px; text-transform: uppercase; cursor: pointer; font-weight: 600; width: fit-content; transition: all 0.3s; }
  .hero-cta:hover { background: #fff; color: #343F86; }
  .hero-counter { position: absolute; top: 28px; right: 72px; font-size: 12px; color: rgba(255,255,255,0.45); z-index: 10; letter-spacing: 2px; }
  .hero-counter-current { color: #fff; font-size: 16px; }
  .hero-arrows { position: absolute; bottom: 80px; right: 72px; display: flex; gap: 10px; z-index: 10; }
  .hero-arrow { width: 46px; height: 46px; border: 1px solid rgba(255,255,255,0.25); background: rgba(0,0,0,0.40); backdrop-filter: blur(6px); display: flex; align-items: center; justify-content: center; color: #fff; font-size: 18px; cursor: pointer; transition: all 0.25s; }
  .hero-arrow:hover { background: #fff; color: #343F86; }
  .hero-dots { position: absolute; bottom: 36px; left: 50%; transform: translateX(-50%); display: flex; gap: 8px; z-index: 10; }
  .hero-dot { height: 2px; width: 18px; background: rgba(255,255,255,0.35); cursor: pointer; transition: all 0.4s; }
  .hero-dot.is-active { width: 38px; background: #fff; }
  .hero-progress { position: absolute; bottom: 0; left: 0; height: 3px; background: rgba(255,255,255,0.50); z-index: 10; width: var(--progress, 0%); transition: width 0.1s linear; }

  /* ── Section shell ────────────────────────────────────────────────────── */
  .section { padding: 20px 0; background: #fff; }
  .section.bg-gray { background: #F6F7FC; }
  .inner { max-width: 1280px; margin: 0 auto; padding: 0 24px; }
  .section-head { margin-bottom: 20px; text-align: left; display: flex; align-items: flex-start; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
  .section-head.center { text-align: center; }
  .section-tag { font-size: 10px; letter-spacing: 3px; text-transform: uppercase; color: #2F8A98; font-weight: 700; display: block; margin-bottom: 10px; }
  .section-title { font-size: clamp(22px,3.2vw,30px); font-weight: 700; color: #343F86; line-height: 1.2; }
  .section-sub { font-size: 14px; color: #5B6072; margin-top: 10px; max-width: 560px; line-height: 1.7; }
  .section-sub.centered { margin: 12px auto 0; text-align: center; }
  .view-all-btn { margin-top: 0; align-self: center; flex-shrink: 0; background: none; border: none; cursor: pointer; font-size: 12px; color: #343F86; font-weight: 700; display: flex; align-items: center; gap: 6px; }

  /* ── Offerings ─────────────────────────────────────────────────────────── */
  .offering-grid { display: grid; grid-template-columns: repeat(auto-fill,minmax(250px,1fr)); gap: 20px; }
  .offering-card { border-radius: 20px; overflow: hidden; cursor: pointer; border: 1px solid #E1E3EE; transition: all 0.3s; box-shadow: 0 2px 10px rgba(0,0,0,0.04); }
  .offering-card:hover { transform: translateY(-8px); box-shadow: 0 20px 52px rgba(0,0,0,0.13); }
  .offering-img { width: 100%; height: 200px; object-fit: cover; }
  .offering-body { padding: 18px 20px 20px; background: #fff; }
  .offering-title { font-size: 14px; font-weight: 600; color: #343F86; margin-bottom: 6px; }
  .offering-sub { font-size: 11px; color: #555763; line-height: 1.5; margin-bottom: 14px; }
  .offering-arrow { width: 34px; height: 34px; background: #343F86; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 14px; }

  /* ── Stories strip ─────────────────────────────────────────────────────── */
  .stories-track { display: flex; gap: 12px; overflow-x: auto; padding-bottom: 8px; scrollbar-width: thin; }
  .story-card { position: relative; border-radius: 16px; overflow: hidden; flex-shrink: 0; width: 180px; height: 220px; cursor: pointer; }
  .story-card.landscape { width: 320px; }
  .story-img { width: 100%; height: 100%; object-fit: cover; }
  .story-grad { position: absolute; inset: 0; background: linear-gradient(to top, rgba(0,0,0,0.65) 0%, transparent 60%); }
  .story-label { position: absolute; bottom: 10px; left: 10px; background: rgba(0,0,0,0.55); backdrop-filter: blur(6px); border-radius: 7px; padding: 4px 10px; font-size: 10px; font-weight: 700; color: #fff; }

  /* ── Why choose us marquee ─────────────────────────────────────────────── */
  .marquee-wrap { overflow: hidden; position: relative; }
  .marquee-inner { display: flex; gap: 20px; width: max-content; transform: translateX(var(--tx, 0)); }
  .why-card { background: #fff; border: 1px solid #ECEEF6; border-radius: 18px; padding: 24px 20px; text-align: center; width: 170px; flex-shrink: 0; box-shadow: 0 4px 16px rgba(0,0,0,0.05); }
  .why-icon { width: 64px; height: 64px; border-radius: 12px; object-fit: contain; margin: 0 auto 10px; display: block; }
  .why-title { font-size: 11px; font-weight: 700; color: #343F86; }

  /* ── Cost calculator cards ─────────────────────────────────────────────── */
  .calc-header { text-align: center; margin-bottom: 40px; }
  .calc-head-row { display: flex; align-items: center; justify-content: center; gap: 10px; flex-wrap: wrap; }
  .calc-head-text, .calc-head-animated { font-size: clamp(18px,3.2vw,30px); font-weight: 700; color: #343F86; }
  .calc-head-animated { border-bottom: 3px solid #343F86; padding-bottom: 2px; }
  .calc-grid { display: grid; grid-template-columns: repeat(auto-fill,minmax(280px,1fr)); gap: 20px; }
  .calc-card { background: #fff; border-radius: 18px; padding: 24px; border: 2px solid #ECEEF6; transition: all 0.3s; box-shadow: 0 4px 14px rgba(0,0,0,0.04); }
  .calc-card:hover { border-color: #343F86; transform: translateY(-4px); box-shadow: 0 14px 42px rgba(0,0,0,0.10); }
  .calc-icons { display: flex; justify-content: space-between; margin-bottom: 18px; }
  .calc-icon-l { width: 56px; height: 56px; border-radius: 12px; object-fit: cover; }
  .calc-icon-r { width: 40px; height: 40px; border-radius: 10px; object-fit: cover; }
  .calc-card-title { font-size: 16px; font-weight: 600; color: #343F86; margin-bottom: 6px; }
  .calc-card-desc { font-size: 11px; color: #555763; line-height: 1.5; margin-bottom: 18px; }
  .calc-btn { background: #343F86; color: #fff; border: none; border-radius: 10px; padding: 11px 22px; font-size: 11px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 6px; }

  /* ── Mid banner (Book Free Consultation) ───────────────────────────────── */
  .mid-banner { padding: 0 24px 30px; background: #F6F7FC; }
  .mid-banner-inner { max-width: 1280px; margin: 0 auto; border-radius: 22px; overflow: hidden; background: linear-gradient(135deg,#343F86 0%,#262E63 100%); padding: 30px 30px; display: flex; align-items: center; justify-content: space-between; gap: 32px; flex-wrap: wrap; position: relative; }
  .mid-banner-tag { font-size: 10px; font-weight: 700; color: #7FD0DA; letter-spacing: 2px; text-transform: uppercase; margin-bottom: 12px; display: flex; align-items: center; gap: 8px; }
  .mid-banner-tag-dot { width: 5px; height: 5px; border-radius: 50%; background: #A7ACBD; flex-shrink: 0; box-shadow: 0 0 0 3px rgba(74,222,128,0.18); }
  .mid-banner-title { font-size: clamp(22px,3.2vw,36px); font-weight: 700; color: #fff; line-height: 1.2; }
  .mid-banner-sub { color: #555763; margin-top: 10px; max-width: 380px; font-size: 13px; line-height: 1.7; }
  .mid-banner-btn { background: #fff; color: #343F86; border: none; border-radius: 50px; padding: 9px 9px 9px 26px; font-size: 13px; font-weight: 700; cursor: pointer; flex-shrink: 0; transition: all 0.3s; display: inline-flex; align-items: center; gap: 16px; box-shadow: 0 8px 24px rgba(0,0,0,0.25); }
  .mid-banner-btn:hover { transform: translateY(-3px); box-shadow: 0 14px 34px rgba(0,0,0,0.32); }
  .mid-banner-btn-arrow { width: 38px; height: 38px; border-radius: 50%; background: #343F86; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 16px; flex-shrink: 0; transition: transform 0.3s, background 0.3s; }
  .mid-banner-btn:hover .mid-banner-btn-arrow { background: #A7ACBD; transform: translateX(3px) rotate(45deg); }

  /* ── Testimonials ──────────────────────────────────────────────────────── */
  .testi-grid { display: grid; grid-template-columns: repeat(auto-fill,minmax(300px,1fr)); gap: 24px; }
  .testi-card { background: #fff; border-radius: 18px; overflow: hidden; border: 1px solid #ECEEF6; box-shadow: 0 4px 20px rgba(0,0,0,0.06); transition: all 0.3s; }
  .testi-card:hover { box-shadow: 0 18px 52px rgba(0,0,0,0.12); transform: translateY(-6px); }
  .testi-img-wrap { position: relative; }
  .testi-img { width: 100%; height: 175px; object-fit: cover; }
  .testi-img-grad { position: absolute; inset: 0; background: linear-gradient(to top, rgba(0,0,0,0.55), transparent); }
  .testi-img-meta { position: absolute; bottom: 10px; left: 0; right: 0; text-align: center; }
  .testi-name { font-size: 12px; font-weight: 700; color: #fff; }
  .testi-loc { font-size: 10px; color: rgba(255,255,255,0.80); }
  .testi-body { padding: 20px 22px; position: relative; }
  .testi-quote { font-size: 38px; color: #E1E3EE; line-height: 1; position: absolute; top: 10px; left: 18px; }
  .testi-text { font-size: 12px; color: #5B6072; line-height: 1.75; font-style: italic; padding-top: 6px; }

  /* ── Hospital gallery (responsive grid) ────────────────────────────────── */
  .gallery-grid { display: grid; grid-template-columns: repeat(4, 1fr); grid-auto-rows: 280px; gap: 10px; }
  .gallery-cell { grid-column: span 1; position: relative; border-radius: 14px; overflow: hidden; cursor: pointer; transition: transform 0.3s; }
  .gallery-cell.col-span-2 { grid-column: span 2; }
  .gallery-cell:hover { transform: scale(1.02); }
  .gallery-cell-img { width: 100%; height: 100%; object-fit: cover; display: block; transition: transform 0.4s; }
  .gallery-cell:hover .gallery-cell-img { transform: scale(1.05); }
  .gallery-cell-label { position: absolute; bottom: 10px; left: 10px; background: rgba(0,0,0,0.55); backdrop-filter: blur(6px); border-radius: 7px; padding: 4px 10px; font-size: 10px; font-weight: 700; color: #fff; }
  .gallery-arrow { position: absolute; top: 50%; transform: translateY(-50%); width: 40px; height: 40px; border-radius: 50%; background: #fff; border: 1px solid #CDD1E0; box-shadow: 0 2px 10px rgba(0,0,0,0.12); display: flex; align-items: center; justify-content: center; font-size: 20px; cursor: pointer; z-index: 10; color: #343F86; transition: all 0.2s; }
  .gallery-arrow:hover { background: #343F86; color: #fff; }
  .gallery-arrow.left { left: -20px; }
  .gallery-arrow.right { right: -20px; }
  .gallery-dots { display: flex; gap: 6px; justify-content: center; margin-top: 18px; }
  .gallery-dot { height: 3px; width: 24px; border-radius: 2px; background: #CDD1E0; cursor: pointer; transition: all 0.3s; }
  .gallery-dot.is-active { width: 36px; background: #343F86; }

  @media (max-width: 900px) {
    .gallery-grid { grid-template-columns: repeat(2, 1fr); grid-auto-rows: 220px; }
    .gallery-cell.col-span-2 { grid-column: span 2; }
    .gallery-arrow { display: none; }
  }
  @media (max-width: 560px) {
    .gallery-grid { grid-template-columns: 1fr; grid-auto-rows: 200px; gap: 8px; }
    .gallery-cell.col-span-2 { grid-column: span 1; }
  }

  /* ── Magazine ──────────────────────────────────────────────────────────── */
  .mag-grid { display: grid; grid-template-columns: repeat(auto-fill,minmax(300px,1fr)); gap: 28px; }
  .mag-card { cursor: pointer; }
  .mag-img-wrap { border-radius: 14px; overflow: hidden; margin-bottom: 14px; }
  .mag-img { width: 100%; height: 220px; object-fit: cover; transition: transform 0.4s; }
  .mag-card:hover .mag-img { transform: scale(1.05); }
  .mag-title { font-family: 'Inter', 'Montserrat', sans-serif; font-size: 14px; font-weight: 600; color: #343F86; line-height: 1.4; margin-bottom: 7px; }
  .mag-meta { font-size: 10px; color: #555763; font-style: italic; }

  /* ── In the news / clients ticker ─────────────────────────────────────── */
  .news-wrap { overflow: hidden; }
  .news-track { display: flex; gap: 22px; width: max-content; transform: translateX(var(--tx, 0)); }
  .news-card {  border-radius: 10px;  flex-shrink: 0; height: 80px; display: flex; align-items: center; justify-content: center; }
  .news-img { height: 72px; max-width: 200px; object-fit: contain; }

  /* ── FAQ ───────────────────────────────────────────────────────────────── */
  .faq-list { max-width: 820px; margin: 0 auto; }
  .faq-item { background: #fff; border-radius: 14px; margin-bottom: 10px; border: 1px solid #ECEEF6; overflow: hidden; transition: box-shadow 0.3s; }
  .faq-item.is-open { box-shadow: 0 6px 24px rgba(0,0,0,0.08); }
  .faq-btn { width: 100%; background: none; border: none; cursor: pointer; padding: 18px 22px; display: flex; justify-content: space-between; align-items: center; text-align: left; gap: 14px; font-size: 13px; font-weight: 600; color: #343F86; }
  .faq-plus { font-size: 18px; color: #343F86; flex-shrink: 0; display: inline-block; transition: transform 0.3s; }
  .faq-item.is-open .faq-plus { transform: rotate(45deg); }
  .faq-ans { padding: 0 22px 18px; font-size: 12px; color: #5B6072; line-height: 1.8; }

  /* ── Dream banner ──────────────────────────────────────────────────────── */
  .dream-banner { background: linear-gradient(135deg,#343F86 0%,#262E63 50%,#343F86 100%); padding: 30px 0px; text-align: center; position: relative; overflow: hidden; }
  .dream-banner-dots { position: absolute; inset: 0; opacity: 0.05; background-image: radial-gradient(circle at 50% 50%, #fff 1px, transparent 1px); background-size: 40px 40px; }
  .dream-banner-title { font-size: clamp(26px,4vw,44px); font-weight: 700; color: #fff; margin-bottom: 14px; line-height: 1.2; position: relative; }
  .dream-banner-sub { color: rgba(255,255,255,0.60); font-size: 14px; margin-bottom: 38px; max-width: 460px; margin-left: auto; margin-right: auto; position: relative; }
  .dream-banner-btn { background: #fff; color: #2F8A98; border: none; border-radius: 12px; padding: 18px 52px; font-size: 14px; font-weight: 800; cursor: pointer; letter-spacing: 0.5px; transition: all 0.3s; text-transform: uppercase; position: relative; }
  .dream-banner-btn:hover { transform: translateY(-4px); box-shadow: 0 18px 52px rgba(255,255,255,0.18); }

  /* ── Consultation modal ───────────────────────────────────────────────── */
  .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.65); backdrop-filter: blur(4px); display: flex; align-items: center; justify-content: center; z-index: 1000; padding: 20px; animation: fadeIn 0.25s ease; }
  .modal-box { position: relative; background: #fff; border-radius: 18px; max-width: 560px; width: 100%; max-height: 90vh; overflow-y: auto; box-shadow: 0 24px 80px rgba(0,0,0,0.35); animation: popIn 0.3s cubic-bezier(0.34,1.56,0.64,1); }
  .modal-close { position: absolute; top: 14px; right: 14px; width: 36px; height: 36px; border-radius: 50%; background: #ECEEF6; border: none; display: flex; align-items: center; justify-content: center; font-size: 18px; color: #343F86; cursor: pointer; z-index: 10; transition: all 0.2s; }
  .modal-close:hover { background: #343F86; color: #fff; }

  /* ── Hero Slider: tablet layout (641–900px) ──────────────────────────── */
  @media (max-width: 900px) {
    .hero-slider-wrap { height: calc(100vh - 60px); min-height: 440px; }
    .hero-content { padding: 0 28px 64px !important; }
    .hero-title { font-size: clamp(28px, 7vw, 40px) !important; margin-bottom: 12px !important; max-width: 100% !important; }
    .hero-stats { gap: 24px !important; margin-bottom: 22px !important; }
    .hero-counter { top: 20px !important; right: 24px !important; font-size: 11px !important; }
    .hero-arrows { right: 24px !important; bottom: 64px !important; }
    .hero-arrow { width: 40px !important; height: 40px !important; }
  }

  /* ── Hero Slider: phone layout (≤640px) ─────────────────────────────── */
  @media (max-width: 640px) {
    .hero-img-desktop { display: none; }
    .hero-img-mobile { display: block; width: 100%; height: 100% !important; object-fit: cover !important; }
    .hero-slider-wrap { height: auto !important; min-height: 0 !important; aspect-ratio: 1024 / 1320; }
    .hero-counter { display: none !important; }
    .hero-arrows { display: none !important; }
    .hero-dots { bottom: 18px !important; } 

    .hero-track { height: 100% !important; }
    .hero-slide { height: 100% !important; }
    .hero-grad { background: linear-gradient(to bottom, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.60) 35%, rgba(0,0,0,0.35) 60%, rgba(0,0,0,0.10) 82%, transparent 100%) !important; }
    .hero-content { justify-content: flex-start !important; align-items: flex-start !important; padding: 14% 18px 0 !important; height: auto !important; gap: 0; }
    .hero-cat { font-size: 10px !important; letter-spacing: 2px !important; margin-bottom: 10px !important; }
    .hero-title { font-size: clamp(20px, 6.5vw, 28px) !important; line-height: 1.28 !important; margin-bottom: 18px !important; max-width: 100% !important; }
    .hero-cta { align-self: flex-end !important; margin-top: 0 !important; padding: 10px 20px !important; font-size: 11px !important; letter-spacing: 1.5px !important; }
  }

  /* ── Book Free Consultation banner: responsive stacking ───────────────── */
  @media (max-width: 700px) {
    .mid-banner-inner { flex-direction: column; align-items: flex-start; padding: 20px 20px !important; }
    .mid-banner-btn { width: 100%; justify-content: center; }
  }

  /* ── Hero Slider: distinct, simplified mobile layout ───────────────────── */
  @media (max-width: 900px) {
    .hero-content { padding: 0 28px 64px; }
    .hero-title { font-size: clamp(28px, 7vw, 40px); margin-bottom: 12px; max-width: 100%; }
    .hero-stats { gap: 24px; margin-bottom: 22px; }
    .hero-counter { top: 20px; right: 24px; font-size: 11px; }
    .hero-arrows { right: 24px; bottom: 64px; }
    .hero-arrow { width: 40px; height: 40px; }
  }
 
`;

/* ─── REUSABLE SECTION WRAPPER ─────────────────────────────────────────────── */
function Section({ title, tag, subtitle, cta, onCtaClick, children, bg = "white", center = false }) {
  return (
    
    <section className={`section ${bg === "gray" ? "bg-gray" : ""}`}>
      <div className="inner">
        {(title || tag) && (
          <div className={`section-head ${center ? "center" : ""}`}>
            <div>
              {tag && <span className="section-tag">{tag}</span>}
              {title && <h2 className="section-title">{title}</h2>}
              {subtitle && <p className="section-sub">{subtitle}</p>}
            </div>
            {cta && (
              <button className="view-all-btn" onClick={onCtaClick}>
                {cta} →
              </button>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}

/* ─── HERO SLIDER (responsive, swipe-enabled on mobile) ────────────────────── */
function HeroSlider({ slides, onSlideClick }) {
  const [active, setActive] = useState(0);
  const [progress, setProgress] = useState(0);
  const progressRef = useRef(null);
  const touchStartX = useRef(null);
  const touchDeltaX = useRef(0);

  useEffect(() => { setActive(0); }, [slides]);

  const startAuto = () => {
    setProgress(0);
    let p = 0;
    clearInterval(progressRef.current);
    progressRef.current = setInterval(() => {
      p += 0.2;
      setProgress(p);
      if (p >= 100) {
        clearInterval(progressRef.current);
        setActive((prev) => (prev + 1) % slides.length);
      }
    }, 10);
  };

  useEffect(() => {
    startAuto();
    return () => clearInterval(progressRef.current);
  }, [active, slides]);

  const goTo = (i) => { clearInterval(progressRef.current); setActive(i); };

  const goToConsultation = () => onSlideClick && onSlideClick();

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchDeltaX.current = 0;
    clearInterval(progressRef.current);
  };
  const handleTouchMove = (e) => {
    if (touchStartX.current === null) return;
    touchDeltaX.current = e.touches[0].clientX - touchStartX.current;
  };
  const handleTouchEnd = () => {
    const delta = touchDeltaX.current;
    const SWIPE_THRESHOLD = 40;
    if (delta > SWIPE_THRESHOLD) {
      goTo((active - 1 + slides.length) % slides.length);
    } else if (delta < -SWIPE_THRESHOLD) {
      goTo((active + 1) % slides.length);
    } else {
      startAuto();
    }
    touchStartX.current = null;
    touchDeltaX.current = 0;
  };

  return (
    <div
      className="hero-slider-wrap"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className="hero-track" style={{ "--tx": `-${active * 100}%` }}>
        {slides.map((sl, i) => (
          <div
            key={i}
            className="hero-slide"
            onClick={goToConsultation}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === "Enter") goToConsultation(); }}
          >
            <img src={sl.img} alt={sl.title || ""} className="hero-img hero-img-desktop" />
            {sl.mobileImg && (
              <img src={sl.mobileImg} alt={sl.title || ""} className="hero-img hero-img-mobile" />
            )}
            <div className="hero-grad" />
            <div className="hero-content">
              {sl.category && (
                <div className="hero-cat">
                  <span className="hero-cat-dot" />
                  {sl.category}
                </div>
              )}
              {sl.title && <h2 className="hero-title">{sl.title}</h2>}
              {sl.desc && <p className="hero-desc">{sl.desc}</p>}
              {sl.stats && sl.stats.length > 0 && (
                <div className="hero-stats">
                  {sl.stats.map(([n, l]) => (
                    <div key={l} className="hero-stat">
                      <div className="hero-stat-num">{n}</div>
                      <div className="hero-stat-label">{l}</div>
                    </div>
                  ))}
                </div>
              )}
              {sl.cta && (
                <button className="hero-cta" onClick={(e) => { e.stopPropagation(); goToConsultation(); }}>
                  {sl.cta} →
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="hero-counter">
        <span className="hero-counter-current">{String(active + 1).padStart(2, "0")}</span> / {String(slides.length).padStart(2, "0")}
      </div>

      <div className="hero-arrows">
        {[
          { label: "‹", fn: () => goTo((active - 1 + slides.length) % slides.length) },
          { label: "›", fn: () => goTo((active + 1) % slides.length) },
        ].map(({ label, fn }) => (
          <button key={label} className="hero-arrow" onClick={(e) => { e.stopPropagation(); fn(); }}>
            {label}
          </button>
        ))}
      </div>

      <div className="hero-dots">
        {slides.map((_, i) => (
          <div key={i}
            className={`hero-dot ${i === active ? "is-active" : ""}`}
            onClick={(e) => { e.stopPropagation(); goTo(i); }}
          />
        ))}
      </div>

      <div className="hero-progress" style={{ "--progress": `${progress}%` }} />
    </div>
  );
}

/* ─── HOSPITAL SECTIONS ────────────────────────────────────────────────────── */
function HospitalOfferings() {
  const navigate = useNavigate();
  return (
    <Section title="One-stop shop for all hospital infrastructure" subtitle="Be it ICU fit-outs, diagnostic centres or full ward blocks, we have it all for your hospital.">
      <div className="offering-grid">
        {HOSPITAL_OFFERINGS.map((o, i) => (
          <div key={i} className="offering-card" onClick={() => navigate(o.path)}>
            <img src={o.img} alt={o.title} className="offering-img" />
            <div className="offering-body">
              <div className="offering-title">{o.title}</div>
              <div className="offering-sub">{o.subtitle}</div>
              <div className="offering-arrow">›</div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}

function HospitalInspirations() {
  return (
    <Section title="Get a glimpse of our hospital projects" subtitle="Completed healthcare infrastructure across India's leading hospitals" cta="View All Projects" bg="gray">
      <div className="stories-track">
        {HOSPITAL_STORIES.map((s, i) => (
          <div key={i} className={`story-card ${s.landscape ? "landscape" : ""}`}>
            <img src={s.img} alt={s.label} className="story-img" />
            <div className="story-grad" />
            <div className="story-label">{s.label}</div>
          </div>
        ))}
      </div>
    </Section>
  );
}

function HospitalWhyChooseUs() {
  const [x, setX] = useState(0);
  const totalW = WHY_CHOOSE_HOSPITAL.length * 190;

  useEffect(() => {
    const t = setInterval(() => {
      setX(p => { const next = p - 1; return next <= -totalW ? 0 : next; });
    }, 20);
    return () => clearInterval(t);
  }, [totalW]);

  const looped = [...WHY_CHOOSE_HOSPITAL, ...WHY_CHOOSE_HOSPITAL];

  return (
    <Section title="Why choose us" center>
      <div className="marquee-wrap">
        <div className="marquee-inner" style={{ "--tx": `${x}px` }}>
          {looped.map((w, i) => (
            <div key={i} className="why-card">
              <img src={w.icon} alt={w.title} className="why-icon" />
              <div className="why-title">{w.title}</div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

function HospitalEnquiryCards() {
  const [spin, setSpin] = useState(0);
  const navigate = useNavigate();
  const labels = ["OT / ICU", "Diagnostic Lab", "Patient Ward"];

  useEffect(() => {
    const t = setInterval(() => setSpin(s => (s + 1) % 3), 2000);
    return () => clearInterval(t);
  }, []);

  return (
    <Section bg="gray">
      <div className="calc-header">
        <div className="calc-head-row">
          <h2 className="calc-head-text">Get the estimate for your</h2>
          <span className="calc-head-animated">{labels[spin]}</span>
        </div>
        <p className="section-sub centered">
          Calculate the approximate cost of your hospital infrastructure project
        </p>
      </div>
      <div className="calc-grid">
        {HOSPITAL_CALCULATORS.map((c, i) => (
          <div key={i} className="calc-card">
            <div className="calc-icons">
              <img src={c.iconL} alt="" className="calc-icon-l" />
              <img src={c.iconR} alt="" className="calc-icon-r" />
            </div>
            <div className="calc-card-title">{c.title}</div>
            <div className="calc-card-desc">{c.desc}</div>
            <button className="calc-btn" onClick={() => navigate("/cost-calculator")}>Enquire Now ›</button>
          </div>
        ))}
      </div>
    </Section>
  );
}

function HospitalMidBanner({ onOpenConsultation }) {
  return (
    <div className="mid-banner">
      <div className="mid-banner-inner">
        <div>
          <div className="mid-banner-tag">
            <span className="mid-banner-tag-dot" />
            NABH compliant · ISO certified · 24/7 support
          </div>
          <h2 className="mid-banner-title">Planning a hospital project?</h2>
          <p className="mid-banner-sub">Get a free consultation with our clinical infrastructure specialists — on-time delivery guaranteed.</p>
        </div>
        <button className="mid-banner-btn" onClick={onOpenConsultation}>
          Book Free Consultation
          <span className="mid-banner-btn-arrow">↗</span>
        </button>
      </div>
    </div>
  );
}

function Testimonials() {
  const navigate = useNavigate();
  return (
    <Section
      title="What our clients say"
      cta="View More"
      onCtaClick={() => navigate("/doctor-feedback")}
    >
      <div className="testi-grid">
        {HOSPITAL_TESTIMONIALS.map((t, i) => (
          <div key={i} className="testi-card">
            <div className="testi-img-wrap">
              <img src={t.img} alt={t.name} className="testi-img" />
              <div className="testi-img-grad" />
              <div className="testi-img-meta">
                <div className="testi-name">{t.name}</div>
                <div className="testi-loc">{t.location}</div>
              </div>
            </div>
            <div className="testi-body">
              <div className="testi-quote">"</div>
              <p className="testi-text">{t.review}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
}

/* ─── HOSPITAL GALLERY (responsive grid: 4-col desktop → 2-col tablet → 1-col mobile) ─ */
function HospitalGallery() {
  const [slide, setSlide] = useState(0);
  const navigate = useNavigate();
  const total = HOSPITAL_GALLERY_SLIDES.length;

  const ArrowBtn = ({ dir }) => (
    <button
      className={`gallery-arrow ${dir === "right" ? "right" : "left"}`}
      onClick={() => setSlide((slide + (dir === "right" ? 1 : -1) + total) % total)}
    >
      {dir === "right" ? "›" : "‹"}
    </button>
  );

  return (
    <Section
      title="A glimpse of our hospital spaces"
      subtitle="Precision-built clinical spaces delivered across India"
      cta="View All Projects"
      onCtaClick={() => navigate("/projects")}
      bg="gray"
    >
      <div style={{ position: "relative" }}>
        <div className="gallery-grid">
          {HOSPITAL_GALLERY_SLIDES[slide].map((h, i) => (
            <div key={i}
              className={`gallery-cell ${h.span === 2 ? "col-span-2" : ""}`}
              onClick={() => h.path && navigate(h.path)}
              role="link"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === "Enter" && h.path) navigate(h.path); }}
            >
              <img src={h.img} alt={h.title} className="gallery-cell-img" />
              <div className="gallery-cell-label">{h.title}</div>
            </div>
          ))}
        </div>
        {slide > 0 && <ArrowBtn dir="left" />}
        {slide < total - 1 && <ArrowBtn dir="right" />}
      </div>
      <div className="gallery-dots">
        {HOSPITAL_GALLERY_SLIDES.map((_, i) => (
          <div key={i} onClick={() => setSlide(i)} className={`gallery-dot ${i === slide ? "is-active" : ""}`} />
        ))}
      </div>
    </Section>
  );
}

function Magazine() {
  const navigate = useNavigate();
  return (
    <Section
      title="Recent Healthcare Infrastructure Projects"
      subtitle="Insights, case studies and expert tips from PR Hospital Designers' clinical build team"
      cta="See more"
      onCtaClick={() => navigate("/projects")}
    >
      <div className="mag-grid">
        {MAGAZINE_POSTS.map((p, i) => (
          <div key={i} className="mag-card">
            <div className="mag-img-wrap">
              <img src={p.img} alt={p.title} className="mag-img" />
            </div>
            <h3 className="mag-title">{p.title}</h3>
            <p className="mag-meta">{p.author}{p.date ? ` | ${p.date}` : ""}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}

function InTheNews() {
  const [x, setX] = useState(0);
  const totalW = NEWS_LOGOS.length * 222;

  useEffect(() => {
    const t = setInterval(() => {
      setX(p => { const next = p - 0.6; return next <= -totalW ? 0 : next; });
    }, 16);
    return () => clearInterval(t);
  }, [totalW]);

  const looped = [...NEWS_LOGOS, ...NEWS_LOGOS];

  return (
    <Section title="Our Clients">
      <div className="news-wrap">
        <div className="news-track" style={{ "--tx": `${x}px` }}>
          {looped.map((n, i) => (
            <div key={i} className="news-card">
              <img src={n.img} alt={n.name} className="news-img" />
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

function FAQSection() {
  const [open, setOpen] = useState(null);
  return (
    <Section title="FAQs About Hospital Infrastructure" bg="gray">
      <div className="faq-list">
        {FAQS.map((f, i) => (
          <div key={i} className={`faq-item ${open === i ? "is-open" : ""}`}>
            <button className="faq-btn" onClick={() => setOpen(open === i ? null : i)}>
              <span>{f.q}</span>
              <span className="faq-plus">+</span>
            </button>
            {open === i && <div className="faq-ans">{f.a}</div>}
          </div>
        ))}
      </div>
    </Section>
  );
}

function DreamBanner({ onOpenConsultation }) {
  return (
    <div className="dream-banner">
      <div className="dream-banner-dots" />
      <h2 className="dream-banner-title">Your dream hospital is just a click away</h2>
      <p className="dream-banner-sub">Let PR Hospital Designers' expert team deliver a world-class clinical environment — on time, every time.</p>
      <button className="dream-banner-btn" onClick={onOpenConsultation}>
        GET STARTED
      </button>
    </div>
  );
}

/* ─── MAIN EXPORT ──────────────────────────────────────────────────────────── */
export default function Home() {
  const [showConsultation, setShowConsultation] = useState(false);

  useEffect(() => {
    if (showConsultation) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [showConsultation]);

  return (
    <>
    <SEO/>
    <h1 style={{ display: "none" }}>
      PR Hospital Designers | Hospital Design & Infrastructure
    </h1>
    <div className="page">
      <style>{GLOBAL_CSS}</style>

      <HeroSlider slides={HOSPITAL_SLIDES} onSlideClick={() => setShowConsultation(true)} />
      <HospitalOfferings />
      <HospitalInspirations />
      <HospitalWhyChooseUs />
      <HospitalEnquiryCards />
      <HospitalMidBanner onOpenConsultation={() => setShowConsultation(true)} />
      <Testimonials />
      <HospitalGallery />
      <Magazine />
      <InTheNews />
      <FAQSection />
      <DreamBanner onOpenConsultation={() => setShowConsultation(true)} />

      {showConsultation && (
        <div className="modal-overlay" onClick={() => setShowConsultation(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowConsultation(false)} aria-label="Close">
              ×
            </button>
            <Consultation />
          </div>
        </div>
      )}
    </div>
    </>
  );
}